import { render, staticRenderFns } from "./ContractorReviewCard.vue?vue&type=template&id=aaaa85ea"
import script from "./ContractorReviewCard.vue?vue&type=script&lang=ts"
export * from "./ContractorReviewCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aaaa85ea')) {
      api.createRecord('aaaa85ea', component.options)
    } else {
      api.reload('aaaa85ea', component.options)
    }
    module.hot.accept("./ContractorReviewCard.vue?vue&type=template&id=aaaa85ea", function () {
      api.rerender('aaaa85ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/companyContractors/ContractorReviewCard.vue"
export default component.exports